import type { JSX } from 'react';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api/client';
import { AuthFrame } from './AuthFrame';

export function LogoutPage(): JSX.Element {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    api
      .logout()
      .catch((err: unknown) => console.error('logout request failed', err))
      .finally(() => {
        localStorage.removeItem('codex_email');
        if (alive) setLoading(false);
      });
    return () => {
      alive = false;
    };
  }, []);

  return (
    <AuthFrame>
      <div className="card card-narrow" style={{ textAlign: 'center' }}>
        <h2
          style={{
            margin: '0 0 var(--space-3)',
            fontSize: 'var(--text-md)',
            color: 'var(--color-ink)',
          }}
        >
          {loading ? 'Signing out…' : "You're signed out"}
        </h2>
        <p className="muted" style={{ margin: '0 0 var(--space-6)', fontSize: 'var(--text-sm)' }}>
          {loading ? 'Clearing your session.' : 'Your session has been ended securely. Thank you.'}
        </p>
        <button
          className="btn btn-primary"
          onClick={() => navigate('/auth/login')}
          disabled={loading}
        >
          Sign in again
        </button>
      </div>
    </AuthFrame>
  );
}
